<template lang="pug">
	a.sponsored-by(
		:href="sponsorLink"
		target="_blank"
		:class="classes"
	)
		span.sponsored-by-text {{ sponsoredByText }}
		img(:src="sponsorURL")
</template>

<script>
import mediaMixin from '../mixins/mediaMixin'
export default {
	mixins: [mediaMixin],
	props: {
		sponsoredByText: {
			type: String,
			default: 'Präsentiert von'
		},
		sponsor: Object,
		sponsorLink: String,

		background: { type: String, default: 'white' },
		layout: { type: String, default: 'row' },
		text: { type: String, default: 'dark' },
		align: { type: String, default: 'left' },
		size: { type: String, default: 'default' }
	},
	computed: {
		sponsorURL () {
			if (!this.sponsor) {
				return null
			}
			return this.getMediaThumbnailURL(this.sponsor)
		},
		classes () {
			return [
				`is-background-${this.background}`,
				`is-text-${this.text}`,
				`is-layout-${this.layout}`,
				`is-align-${this.align}`,
				`is-size-${this.size}`
			]
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/bulma-variables.scss';
	a.sponsored-by {
		display: inline-flex;
		align-items: center;
		padding: 4px 10px;
		display: flex;
		text-decoration: none !important;

		&:hover {
			opacity: 0.8;
		}
		.sponsored-by-text {
			font-weight: bold;
			text-transform: uppercase;
			font-size: 0.85em;
		}
		img {
			width: auto;
			height: auto;
			max-height: 100px;
			max-width: 300px;
		}
		&.is-layout-row {
			flex-direction: row;
			img { margin-left: 0.5em; }
		}
		&.is-layout-column {
			flex-direction: column;
			img { margin-top: 0.5em; }
		}
		&.is-align-left {
			&.is-layout-row { justify-content: flex-start; }
			&.is-layout-column { align-items: flex-start; }
		}
		&.is-align-center {
			&.is-layout-row { justify-content: center; }
			&.is-layout-column { align-items: center; }
			.sponsored-by-text {
				text-align: center;
			}
		}
		&.is-align-right {
			&.is-layout-row { justify-content: flex-end; }
			&.is-layout-column { align-items: flex-end; }
		}
		&.is-text-dark { color: $dark; 	}
		&.is-text-white { color: $white; 	}
		&.is-background-white { background: $white; 	}
		&.is-background-clear { background: transparent; }

		&.is-size-default img {
			max-height: 100px;
			max-width: 300px;
		}
		&.is-size-medium img {
			max-height: 150px;
			max-width: 375px;
		}

		&.is-size-large img {
			max-height: 200px;
			max-width: 450px;
		}

		@media screen and (max-width: 768px) {
			&.is-layout-column,
			&.is-layout-row {
				flex-direction: column;

				.sponsored-by-text {
					font-size: 0.75em;
					margin-top: 1em;
				}
				img {
					margin-left: 0;
					margin-top: 0.5em;
				}
			}
		}
	}
</style>
